import React from 'react';

export default function NoData(props)
{
	return (
		<div className='flexCol alignCntr jcCntr flexGrow pdngTLG'>
			<div className='nodataImg borderRadius50 baseDarkBg pdngLG'>
				<img
					src={props.src ? props.src : '/images/nodata.png'}
					alt='no data'
					className='invertPrimary'
				/>
			</div>
			<div className='flexCol alignCntr'>
				<h3 className='txtCntr mrgnSM'>{props.nodata}</h3>
				<p className='txtCntr mrgnSM'>{props?.nodata_msg}</p>
			</div>
		</div>
	);
}